import ClientRegistrationApprovalCont from '../../components/Sales/ClientRegistration/ClientRegistrationApprovalCont'
import ClientRegistrationCont from '../../components/Sales/ClientRegistration/ClientRegistrationCont'
import EnquiriesCont from '../../components/Sales/Enquiries/EnquiriesCont'
import React from 'react'
import ClientsList from '../../components/Sales/ClientsList'
import Client from '../../components/Sales/Client/ClientCont'
import { Route, Switch } from 'react-router-dom'
import NoMatchComponent from '../../components/NoMatch'
import InvoicesCont from '../../components/Sales/Invoices/InvoicesCont'
import Dropdowns from '../../modules/Dropdowns'
import PaymentsCont from '../../components/Sales/Payments/PaymentsCont'
import DepositsCont from '../../components/Sales/Deposits/DepositsCont'
import AddOrderCont from '../../components/Sales/Orders/AddOrder/AddOrderCont'
import AddQuoteCont from '../../components/Sales/Quotes/AddQuote/AddQuoteCont'
import ViewContractCont from '../../components/Sales/Client/Contract/ViewContract/ViewContractCont'
import NewClientCont from '../../components/Sales/NewClient/NewClientCont'
import AddContractCont from '../../components/Sales/Client/Contract/AddContract/AddContractCont'
import ReceiptsCont from '../../components/Sales/Payments/Receipts/ReceiptsCont'
import ViewReceiptCont from '../../components/Sales/Payments/Receipts/ViewReceipt/ViewReceiptCont'
import ViewInvoiceCont from '../../components/Sales/Invoices/ViewInvoice/ViewInvoiceCont'
import AddReceiptCont from '../../components/Sales/Payments/AddReceipt/AddReceiptCont'
import QuotesCont from '../../components/Sales/Quotes/QuotesCont'
import { BUDGET_TYPE_SALES } from '../../components/Common/Budgets/BudgetCont'
import BudgetsCont from '../../components/Corporate/Budgets/BudgetsCont'
import OrdersCont from '../../components/Sales/Orders/OrdersCont'
import AddEnquiriesCont from '../../components/Sales/Enquiries/AddEnquiry/AddEnquiriesCont'

export default function ClientRouter(props) {
  const url = props.match.url
  React.useEffect(() => {
    new Dropdowns({ dropdown: 'general', name: 'currency' }).set()
    new Dropdowns({ dropdown: 'general', name: 'state' }).set()
  }, [])

  return (
    <Switch>
      <Route path={`${url}/registration/:key`} component={ClientRegistrationApprovalCont} />
      <Route path={`${url}/registration`} component={ClientRegistrationCont} />
      <Route path={`${url}/enquiries/:key/update`} component={AddEnquiriesCont} />
      <Route path={`${url}/enquiries/new`} component={AddEnquiriesCont} />
      <Route path={`${url}/enquiries`} component={EnquiriesCont} />
      <Route path={`${url}/invoices/:key/view`} component={ViewInvoiceCont} />
      <Route path={`${url}/receipts/:key/view`} component={ViewReceiptCont} />
      <Route path={`${url}/payments/:key/add`} component={AddReceiptCont} />
      <Route path={`${url}/payments/:key/deposit`} component={AddReceiptCont} />
      <Route path={`${url}/payments/`} component={PaymentsCont} />
      <Route path={`${url}/receipts/`} component={ReceiptsCont} />
      <Route path={`${url}/invoices/`} component={InvoicesCont} />
      <Route path={`${url}/deposits/`} component={DepositsCont} />
      <Route
        path={`${url}/budgets/`}
        component={() => <BudgetsCont option={BUDGET_TYPE_SALES} />}
      />
      <Route path={`${url}/orders/:key/update`} component={AddOrderCont} />
      <Route path={`${url}/orders/new`} component={AddOrderCont} />
      <Route path={`${url}/orders/`} component={OrdersCont} />
      <Route path={`${url}/quotes/:key/update`} component={AddQuoteCont} />
      <Route path={`${url}/quotes/new`} component={AddQuoteCont} />
      <Route path={`${url}/quotes/`} component={QuotesCont} />
      <Route path={`${url}/list`} component={ClientsList} />
      <Route path={`${url}/new`} component={NewClientCont} />
      <Route path={`${url}/:key/contracts/new`} component={AddContractCont} />
      <Route path={`${url}/:key/contracts/:contractKey/update`} component={AddContractCont} />
      <Route path={`${url}/:key/contracts/:contractKey/view`} component={ViewContractCont} />
      <Route path={`${url}/:key/`} component={Client} />
      <Route path="*" component={NoMatchComponent} />
    </Switch>
  )
}
